import { render, staticRenderFns } from "./PropertyActions.vue?vue&type=template&id=046402c0&"
import script from "./PropertyActions.vue?vue&type=script&lang=js&"
export * from "./PropertyActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports